import React from "react";
import { Box } from "@mui/material";
import {
  GeneralSettingView,
  SixtyISettings,
  FortyThreeISetting,
  AutoZeroSettings,
  ResponseTimeSettings,
  GasCylinderSettings,
  PIDControllersSettings,
  QAL3Settings,
  SO2ScrubberSettings,
  StabilitySettings,
} from "Components/settings";
import { useSettingsConfig } from "../../hooks/useReduxSelectors";
import SystemModuleSettings from "../../components/settings/systemModuleSettings";
import { useMsal } from "Auth/msal-context";
import AnalogSignalSettings from "../../components/settings/analogSignalSettings";


const SettingsContainer = () => {
  const settingsConfig = useSettingsConfig();
  const { isAuthorized, isEdge } = useMsal();

  if (settingsConfig) {
    return (
      <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
        {settingsConfig.General && <GeneralSettingView />}
        {settingsConfig["60i"] && <SixtyISettings />}
        {settingsConfig["43i"] && <FortyThreeISetting />}
        {settingsConfig.autoZero && <AutoZeroSettings />}
        {settingsConfig.gasCylinders && <GasCylinderSettings />}
        {settingsConfig.PIDcontrollers && <PIDControllersSettings />}
        {settingsConfig.QAL3 && <QAL3Settings />}
        {settingsConfig.responsetime && <ResponseTimeSettings />}
        {settingsConfig.SO2Scrubber && <SO2ScrubberSettings />}
        {settingsConfig.analogSignal && <AnalogSignalSettings />}
        {settingsConfig.stabilization && <StabilitySettings />}
        {/* <SystemModuleSettings
          isAuthorized={isAuthorized}
          isEdge={isEdge}
        /> */}
      </Box>
    );
  } else {
    return (
      <Box sx={{ position: 'relative', m: '10px', width: '100%' }}>
        <div style={{ textAlign: "center" }}>No Settings Available</div>
      </Box>
    );
  }
};

export default SettingsContainer;
